import fetch from 'utils/fetch';

export function roleList(roleName,psize,currentPage) {
    const data = {
        roleName,
        psize,
        currentPage
    };
    return fetch({
        url: '/roleList',
        method: 'get',
        params : data
    });
}

/**
 * 获取所有/指定角色权限
 */
export function getMenu(roleId){
    const data = {
        roleId
    };
    return fetch({
        url: '/menu',
        method: 'GET',
        params : data
    })
}
/**
 * 获取当前登入用户的所有权限
 */
export function getUserPermission(){
    return fetch({
        url: '/userPermission',
        method: 'GET'
    })
}

/**
 * 批量保存权限
 */
export function batchSavePermission (params){
    return fetch({
        url: 'batchSavePermission',
        method: 'POST',
        data: params
    })
}

export function addRole(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/addRole',
        method: 'post',
        data
    });
}

export function upRole(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/upRole',
        method: 'put',
        data
    });
}
export function batchaDelRole(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/batchaDelRole',
        method: 'post',
        data
    });
}





// WEBPACK FOOTER //
// ./src/api/role.js